const tr = {
  premiumInterview: {
    badge: "Premium AI Deneyimi",
    heroTitle1: "Gerçek Zamanlı",
    heroTitle2: "AI Avatar Mülakatı",
    windowTitle: "HireThink Premium Canlı AI Mülakat",
    heroSubtitle: "En gelişmiş yapay zeka teknolojisi ile adaylarınızla gerçek bir mülakat deneyimi yaşatın. Canlı avatar, doğal konuşma ve anlık analiz ile işe alım sürecinizi dönüştürün.",
    imageAlt: "Premium AI Avatar Mülakat Deneyimi",
    floatBadge1Title: "7/24 Mülakat",
    floatBadge1Desc: "Her zaman hazır",
    floatBadge2Title: "Sınırsız Aday",
    floatBadge2Desc: "Aynı anda",
    floatBadge3Title: "Doğal Diyalog",
    floatBadge3Desc: "Gerçekçi deneyim",
    featuresTitle: "Premium Mülakat Özellikleri",
    featuresSubtitle: "En gelişmiş AI teknolojisi ile donatılmış mülakat deneyimi",
    feature1Title: "Farklı Avatar Seçenekleri",
    feature1Desc: "Birbirinden farklı görünüm ve karakterde avatarlar arasından şirketinize en uygun olanı seçin. Her avatar profesyonel ve güvenilir bir mülakat deneyimi sunar.",
    feature2Title: "Şirkete Özel Fine-Tuning",
    feature2Desc: "Okunuşunu beğenmediğiniz kelimeler veya sektörel terimler için çok kısa sürede şirketinize özel telaffuz ayarlaması yapın. Avatar tam istediğiniz gibi konuşsun.",
    feature3Title: "Gelişmiş Anomali Tespiti",
    feature3Desc: "Göz hareketleri, yüz ifadeleri ve ses tonunu analiz ederek olağandışı durumları tespit eder. Mülakat bütünlüğünü korur.",
    feature4Title: "Çoklu Dil Desteği",
    feature4Desc: "30'dan fazla dilde doğal konuşma desteği. Farklı aksanları anlama ve doğru telaffuz ile global yetenek havuzuna erişin.",
    feature5Title: "Güvenli & KVKK Uyumlu",
    feature5Desc: "Tüm mülakat kayıtları şifreli ve güvenli sunucularda saklanır. KVKK ve GDPR standartlarına tam uyumluluk.",
    feature6Title: "Detaylı Analitik Raporlar",
    feature6Desc: "Yetkinlik bazlı puanlama, duygu analizi ve karşılaştırmalı değerlendirmeler ile veriye dayalı kararlar verin.",
    benefitsTitle: "Neden Premium Mülakat?",
    benefitsSubtitle: "İşe alım sürecinizi bir üst seviyeye taşıyın",
    benefit1: "Adaylara gerçek bir mülakat deneyimi sunun",
    benefit2: "Zaman ve maliyet tasarrufu sağlayın",
    benefit3: "Tüm adaylara eşit ve standart değerlendirme",
    benefit4: "7/24 kesintisiz mülakat imkanı",
    benefit5: "Detaylı yetkinlik analizleri ile doğru kararlar",
    benefit6: "Employer brand imajınızı güçlendirin",
    ctaTitle: "Premium AI Mülakatı Deneyin",
    ctaSubtitle: "Hemen demo talep edin ve işe alım sürecinizi dönüştürün",
    ctaButton: "Demo Talep Et"
  },
  standardInterview: {
    heroTitle1: "Standart Videolu",
    heroTitle2: "AI Mülakat",
    windowTitle: "HireThink Standart Videolu AI Mülakat",
    heroSubtitle: "Asenkron video mülakatlarını AI yönetsin; interviewer videolarını AI üretsin, anında skor ve paylaşılabilir raporlar sunulsun.",
    imageAlt: "Standart videolu AI mülakat deneyimi",
    floatBadge1Title: "7/24 Mülakat",
    floatBadge1Desc: "Her zaman hazır",
    floatBadge2Title: "Sınırsız Aday",
    floatBadge2Desc: "Aynı anda",
    floatBadge3Title: "Gelişmiş Özelleştirme",
    floatBadge3Desc: "1000+ hazır avatar",
    featuresTitle: "Standart Video Özellikleri",
    featuresSubtitle: "Şeffaf skorlama ile güvenilir asenkron video mülakat",
    feature1Title: "1000+ Avatar Seçeneği",
    feature1Desc: "Birbirinden farklı görünüm ve karakterde avatarlar arasından şirketinize en uygun olanı seçin veya kendi avatarınızı oluşturun.",
    feature2Title: "Şirkete Özel Fine-Tuning",
    feature2Desc: "Beğenmediğiniz kelimeler veya sektörel terimler için hızlı telaffuz ayarı yapın; avatar tam istediğiniz gibi konuşsun.",
    feature3Title: "Gelişmiş Anomali Tespiti",
    feature3Desc: "Adayın hareketlerini ve tarayıcı hareketlerini analiz ederek olana dışı durumları raporda bildirip kayıt altında tutar.",
    feature4Title: "Çoklu Dil Desteği",
    feature4Desc: "30+ dilde doğal konuşma; aksan dostu tanıma ve doğru telaffuz.",
    feature5Title: "Güvenli & KVKK Uyumlu",
    feature5Desc: "Kayıtlar şifreli, güvenli sunucularda; KVKK/GDPR uyumlu.",
    feature6Title: "Detaylı Analitik Raporlar",
    feature6Desc: "Yetkinlik bazlı skorlar, Soru cevap skorları, Anomali tespiti ve karşılaştırmalı değerlendirmelerle veriye dayalı kararlar alın.",
    ctaTitle: "Standart AI Mülakatı Deneyin",
    ctaSubtitle: "Hemen demo talep edin ve işe alım sürecinizi dönüştürün",
    ctaButton: "Demo Talep Et"
  },
  voiceInterview: {
    heroTitle1: "Sesli",
    heroTitle2: "AI Mülakat",
    windowTitle: "HireThink Sesli AI Mülakat",
    heroSubtitle: "Planlama olmadan telefon benzeri AI mülakat; doğal diyalog ve anlık skor.",
    imageAlt: "Sesli AI mülakat deneyimi",
    floatBadge1Title: "7/24 Mülakat",
    floatBadge1Desc: "Her zaman hazır",
    floatBadge2Title: "Sınırsız Aday",
    floatBadge2Desc: "Aynı anda",
    floatBadge3Title: "Erişilebilir",
    floatBadge3Desc: "Telefondan Kolay Kullanım",
    featuresTitle: "Sesli Mülakat Özellikleri",
    featuresSubtitle: "Dakikalar içinde analiz edilen en erişilebilir mülakat modeli",
    feature1Title: "Her Yerden Erişim",
    feature1Desc: "Her cihazdan, her yerden katılın; zayıf internet bağlantısı ve düşük donanım gereksinimlerine bile mükemmel çözüm sunar.",
    feature2Title: "Şirkete Özel Fine-Tuning",
    feature2Desc: "Okunuşunu beğenmediğiniz kelimeler veya sektörel terimler için çok kısa sürede şirketinize özel telaffuz ayarlaması yapın. Avatar tam istediğiniz gibi konuşsun.",
    feature3Title: "Gelişmiş Anomali Tespiti",
    feature3Desc: "Göz hareketleri, yüz ifadeleri ve ses tonunu analiz ederek olağandışı durumları tespit eder. Mülakat bütünlüğünü korur.",
    feature4Title: "Çoklu Dil Desteği",
    feature4Desc: "30'dan fazla dilde doğal konuşma desteği. Farklı aksanları anlama ve doğru telaffuz ile global yetenek havuzuna erişin.",
    feature5Title: "Güvenli & KVKK Uyumlu",
    feature5Desc: "Tüm mülakat kayıtları şifreli ve güvenli sunucularda saklanır. KVKK ve GDPR standartlarına tam uyumluluk.",
    feature6Title: "Detaylı Analitik Raporlar",
    feature6Desc: "Yetkinlik bazlı puanlama, duygu analizi ve karşılaştırmalı değerlendirmeler ile veriye dayalı kararlar verin.",
    ctaTitle: "Sesli AI Mülakatı Deneyin",
    ctaSubtitle: "Hemen demo talep edin ve işe alım sürecinizi dönüştürün",
    ctaButton: "Demo Talep Et"
  },
  whatsappInterview: {
    heroTitle1: "WhatsApp",
    heroTitle2: "AI Mülakat",
    windowTitle: "HireThink WhatsApp Mülakat",
    heroSubtitle: "Adaylarınıza tanıdık oldukları platform üzerinden yapay zeka destekli yazılı mülakat yapın. İş arayışı takibi ve süreç bildirimleri de WhatsApp üzerinden.",
    imageAlt: "WhatsApp AI mülakat deneyimi",
    floatBadge1Title: "Anlık Etkileşim",
    floatBadge1Desc: "Gerçek zamanlı AI",
    floatBadge2Title: "Kolay Erişim",
    floatBadge2Desc: "Uygulama indirme yok",
    floatBadge3Title: "Süreç Takibi",
    floatBadge3Desc: "Otomatik bildirim",
    featuresTitle: "WhatsApp Mülakat Özellikleri",
    featuresSubtitle: "Adayların günlük kullandığı platform üzerinden anlık, yapay zeka destekli mülakat deneyimi",
    feature1Title: "Tanıdık Platform, Sıfır Eğitim",
    feature1Desc: "Adaylar uygulama indirmez, portal öğrenmez. Zaten her gün kullandıkları WhatsApp üzerinden mülakata katılır. Giriş oranı %90'ın üzerinde.",
    feature2Title: "Anlık AI Etkileşimi",
    feature2Desc: "Yapay zeka her yanıtı gerçek zamanlı olarak değerlendirir, konuşmanın akışını yönetir ve adayın cevabına göre soru serisini dinamik olarak ilerletir.",
    feature3Title: "İş Arayışı Durumu Takibi",
    feature3Desc: "WhatsApp üzerinden adayın aktif iş arayışının devam edip etmediğini sorgulayın. Uygun adayları anlık olarak sürece dahil edin.",
    feature4Title: "Süreç Bildirimleri",
    feature4Desc: "Mülakat daveti, hatırlatmalar, sonuç bildirimleri ve bir sonraki adımlar otomatik olarak WhatsApp mesajı ile adaya iletilir.",
    feature5Title: "Güvenli & KVKK Uyumlu",
    feature5Desc: "Tüm konuşma verileri şifreli sunucularda güvenle saklanır. KVKK ve GDPR standartlarına tam uyumluluk.",
    feature6Title: "Detaylı Yetkinlik Raporu",
    feature6Desc: "Yazılı yanıtlar AI tarafından rubric bazlı puanlanır; yetkinlik skoru, güçlü ve gelişim alanları raporla işe alım uzmanına sunulur.",
    ctaTitle: "WhatsApp AI Mülakatı Deneyin",
    ctaSubtitle: "Hemen demo talep edin ve işe alım sürecinizi dönüştürün",
    ctaButton: "Demo Talep Et"
  },
  phoneInterview: {
    heroTitle1: "Telefon",
    heroTitle2: "AI Mülakat",
    windowTitle: "HireThink Telefon Mülakat",
    heroSubtitle: "0850 numaralı HireThink AI hattı adayı arar. Gerçek zamanlı, tamamen sesli, interaktif yapay zeka mülakatı — telefon dışında hiçbir şey gerekmez.",
    imageAlt: "Telefon AI mülakat deneyimi",
    floatBadge1Title: "Otomatik Arama",
    floatBadge1Desc: "AI sizi arar",
    floatBadge2Title: "Anlık Değerlendirme",
    floatBadge2Desc: "Gerçek zamanlı analiz",
    floatBadge3Title: "Her Telefondan",
    floatBadge3Desc: "Uygulama gerekmez",
    featuresTitle: "Telefon Mülakat Özellikleri",
    featuresSubtitle: "0850 numaralı HireThink AI hattı ile tamamen otomatik, interaktif sesli mülakat",
    feature1Title: "AI Otomatik Arama",
    feature1Desc: "HireThink AI, 0850 307 80 61 numarasından adayı arar. Aday telefonu açar açmaz kişiselleştirilmiş mülakat başlar; ek bir giriş veya bağlantıya gerek yoktur.",
    feature2Title: "Soruyu Yeniden Dinleme",
    feature2Desc: "Aday soruyu anlamadıysa veya tekrar duymak isterse sesli olarak talep edebilir. AI soruyu net ve açık biçimde tekrar okur.",
    feature3Title: "Uygun Saate Erteleme",
    feature3Desc: "Aday o anda mülakata uygun değilse saat ve gün belirtebilir. AI randevu oluşturur ve belirlenen saatte otomatik olarak geri arar.",
    feature4Title: "Alakasız Yanıt Tespiti",
    feature4Desc: "Yanıt soruyla ilgili değilse AI bunu tespit eder ve adaydan soruyla ilgili bir yanıt vermesini kibarca ister. Mülakat kalitesi korunur.",
    feature5Title: "Gerçek Zamanlı Ses Analizi",
    feature5Desc: "AI; yanıtın içeriğini, ses tonunu, akıcılığını ve yetkinlik uyumunu eş zamanlı analiz eder. Mülakat biter bitmez yetkinlik raporu hazır olur.",
    feature6Title: "Tam Otomatik Süreç",
    feature6Desc: "İşe alım uzmanının müdahalesi olmadan yüzlerce adayı aynı anda değerlendirin. Tüm görüşmeler kayıt altına alınır ve raporlanır.",
    ctaTitle: "Telefon AI Mülakatı Deneyin",
    ctaSubtitle: "Hemen demo talep edin ve işe alım sürecinizi dönüştürün",
    ctaButton: "Demo Talep Et"
  },
  textInterview: {
    heroTitle1: "Yazılı",
    heroTitle2: "AI Mülakat",
    windowTitle: "HireThink Yazılı AI Mülakat",
    heroSubtitle: "Erken aşama tarama için yapılandırılmış yazılı mülakatlar; AI rubric skoru ile.",
    imageAlt: "Yazılı AI mülakat deneyimi",
    floatBadge1Title: "Düşük Ücret",
    floatBadge1Desc: "En uygun fiyat",
    floatBadge2Title: "Sınırsız Aday",
    floatBadge2Desc: "Aynı anda",
    floatBadge3Title: "Erişilebilir",
    floatBadge3Desc: "Her yerden erişim",
    featuresTitle: "Yazılı Mülakat Özellikleri",
    featuresSubtitle: "Düşük sürtünmeli yazılı mülakatlarla erken tarama",
    feature1Title: "Her Yerden Erişim",
    feature1Desc: "Her cihazdan, her yerden katılın; zayıf internet bağlantısı ve düşük donanım gereksinimlerine bile mükemmel çözüm sunar.",
    feature2Title: "Soru Çeşitliği",
    feature2Desc: "İster kendi sorularınızı yazın, ister AI tarafından soru üretimi yapın. Farklı seviyeler ve farklı soru tipleri ile adaylarınızın yeteneklerini değerlendirin.",
    feature3Title: "Anomali Tespiti",
    feature3Desc: "Benzerlik kontrolleri, AI-üretimi yanıt tespiti ve tarayıcı hareketlerini analiz ederek olağandışı durumları kayıt altında tutup raporda bildirir.",
    feature4Title: "Dil esnekliği",
    feature4Desc: "Türkçe, İngilizce, Almanca, Fransızca, İspanyolca, İtalyanca, Portekizce, Hollandaca, Lehçe, Çekçe, İsveççe, Norveççe, Danca ve 30+ dilde yazılı mülakat desteği.",
    feature5Title: "Güvenli & KVKK Uyumlu",
    feature5Desc: "Tüm mülakat kayıtları şifreli ve güvenli sunucularda saklanır. KVKK ve GDPR standartlarına tam uyumluluk.",
    feature6Title: "Detaylı Analitik Raporlar",
    feature6Desc: "Yetkinlik bazlı puanlama, duygu analizi ve karşılaştırmalı değerlendirmeler ile veriye dayalı kararlar verin.",
    ctaTitle: "Yazılı AI Mülakatı Deneyin",
    ctaSubtitle: "Hemen demo talep edin ve işe alım sürecinizi dönüştürün",
    ctaButton: "Demo Talep Et"
  },
  peerInterviewPage: {
    heroTitle1: "Ekip Bazlı",
    heroTitle2: "Seçim",
    windowTitle: "HireThink Peer Interview",
    heroSubtitle: "Son aşamaya kadar yükselen adayları, beraber çalışacağı ekip arkadaşlarına oylatarak seçtirin.",
    imageAlt: "Peer interview deneyimi",
    floatBadge1Title: "Ekip Oylaması",
    floatBadge1Desc: "Takım arkadaşı seçimi",
    floatBadge2Title: "Anonim Sistem",
    floatBadge2Desc: "Adil değerlendirme",
    floatBadge3Title: "Devlerin Seçimi",
    floatBadge3Desc: "Dünya devleri kullanıyor",
    featuresTitle: "Peer Interview Özellikleri",
    featuresSubtitle: "Ekibinizin ihtiyacını en iyi ekip bilir - eşit ve adil seçim süreci",
    feature1Title: "Anonim Aday Bilgileri",
    feature1Desc: "Son aşamaya kadar yükselen adayların bilgileri anonim bir şekilde sisteme yüklenir. Potansiyel ekip arkadaşlarına gönderilen link üzerinden her ekip üyesi adayları görüntüleyebilir.",
    feature2Title: "Karşılaştırma ve Puanlama",
    feature2Desc: "Ekip üyeleri adayların bilgilerini detaylı olarak inceleyip karşılaştırabilir. Her bir aday için puan vererek en uygun takım arkadaşını belirlerler.",
    feature3Title: "Anonim Soru-Cevap",
    feature3Desc: "Ekip üyeleri dilerlerse adaylara anonim bir şekilde soru sorabilir. Soru sorulduğunda adaya SMS ile bildirim gider ve aday sisteme girip anonim olarak cevap verir.",
    feature4Title: "Şeffaf Süreç",
    feature4Desc: "Adayların verdiği cevaplar tüm ekip üyelerine açık olur. Bu sayede herkes aynı bilgilere sahip olur ve daha adil bir değerlendirme yapılır.",
    feature5Title: "Ekip Oylaması",
    feature5Desc: "Tüm değerlendirmeler tamamlandıktan sonra ekip üyelerinin verdiği puanlar toplanır ve en uygun aday seçilir. Herkes kendi takım arkadaşını eşit bir şekilde seçmiş olur.",
    feature6Title: "Dünya Devlerinin Yöntemi",
    feature6Desc: "Google, Stripe, LinkedIn, GitLab, Atlassian, Amazon gibi büyük şirketlerin kullandığı bu yöntem, bir ekibin neye ihtiyacı olduğunu en iyi ekip bildiği için tercih edilir.",
    ctaTitle: "Peer Interview'ı Deneyin",
    ctaSubtitle: "Hemen demo talep edin ve ekip bazlı seçim sürecinizi başlatın",
    ctaButton: "Demo Talep Et"
  },
  cvScoring: {
    heroTitle1: "AI Tabanlı",
    heroTitle2: "CV Skorlama",
    windowTitle: "HireThink CV Skorlama",
    heroSubtitle: "Tüm başvurularınızı tek sayfada toplayın, farklı formatlardaki CV'leri yapay zeka ile değerlendirin ve kriterlerinize göre puanlayın.",
    imageAlt: "CV Skorlama Dashboard",
    floatBadge1Title: "Hızlı Analiz",
    floatBadge1Desc: "Saniyeler içinde skorlama",
    floatBadge2Title: "İhtiyaca Yönelik",
    floatBadge2Desc: "İş ilanınıza göre kriter oluşturma",
    floatBadge3Title: "Detaylı Rapor",
    floatBadge3Desc: "Kapsamlı analiz",
    featuresTitle: "CV Skorlama Özellikleri",
    featuresSubtitle: "AI tabanlı CV değerlendirme ile işe alım sürecinizi hızlandırın",
    feature1Title: "Kolay Başvuru Kolay Takip",
    feature1Desc: "Tüm başvurularınızı tek bir platformda toplayın ve kolayca takip edin. Başvuru durumlarını anlık olarak görüntüleyin ve yönetin.",
    feature2Title: "Detaylı Analizler",
    feature2Desc: "Her CV için kapsamlı analiz raporları alın. Yetkinlikler, deneyim, eğitim ve diğer kriterlere göre detaylı değerlendirme yapın.",
    feature3Title: "Toplu CV Yükleme",
    feature3Desc: "İster başvuru yönlendirerek isterseniz toplu bir şekilde yükleyerek tüm adaylarınızı yapay zeka ile değerlendirin.",
    feature4Title: "Rapor Çıktısı Alabilme",
    feature4Desc: "Analiz sonuçlarını PDF olarak indirin. Raporları ekibinizle paylaşın ve arşivleyin.",
    feature5Title: "İş İlanı Kriterlerine Göre Puanlama",
    feature5Desc: "Her bir ilanınıza özel olarak yapay zeka ile kriter ve ağırlıkları oluşturun, CV'leri bu kriterlere göre otomatik olarak puanlayın ve en uygun adayları hızlıca bulun.",
    feature6Title: "Gelişim Önerileri",
    feature6Desc: "Adaylarınız için kişiselleştirilmiş gelişim önerileri alın; ilanınızdaki role göre eksik kalan noktaları yakalayın. Üstelik adaylarınızın eksikleri için önerilen kurs ve kaynaklarla adaylarınızı hızlıca geliştirip şirketiniz için en doğru seviyeye taşıyın. "
  },
  nav: {
    cvScoring: "CV Skorlama",
    interviews: "Mülakatlar",
    peerInterview: "Ekip Bazlı Seçim",
    assessments: "Değerlendirmeler",
      ats: "ATS",
      training: "Eğitim",
    pricing: "Pricing",
    contact: "İletişim",
    login: "Giriş Yap",
    getStarted: "Giriş Yap"
  },
  nav_dropdown: {
    premiumLiveAI: "Premium Canlı AI Mülakatı",
    standardVideoAI: "Standart Videolu AI Mülakatı",
    voiceInterview: "Sesli Mülakat",
    textInterview: "Yazılı Mülakat",
    whatsappInterview: "WhatsApp Mülakat",
    phoneInterview: "Telefon Mülakatı",
    interviewObserver: "AI Mülakat Gözlemcisi"
  },
  hero: {
    headline1: "Gerçek",
    headline2: "Yapay Zeka Mülakatı",
    talentHeadline1: "AI Tabanlı",
    talentHeadline2: "İşe Hazırlık Koçun",
    subheadline: "iş başvurusundan, işe yerleştirmeye kadar, süreçlerinize yapay zeka ile çağ atlatın",
    talentSubheadline: "Rolüne özel gerçekçi mülakat provası yap, cevaplarını anında analiz ettir, CV’ni güçlendir ve görüşmeye özgüvenle gir.",
    toggleHiring: "İşverenim",
    toggleTalent: "Adayım",
    toggleComingSoon: "yakında",
    heroBadge: "Sektörün en iyi ve en kapsamlı yapay zeka İK ürünü ile tanışın",
    ctaHiring: "Hemen Başla",
    ctaTalent: "Hemen Başla",
    talentExternalLink: "Aday platformunu aç",
    reviews: "değerlendirme",
    badge1Title: "Yetkinlik Odaklı",
    badge1Desc: "Somut yetkinliklere göre değerlendirin.",
    badge2Title: "Standardize Mülakat",
    badge2Desc: "Her adaya aynı sorularla, aynı kriterlerle yaklaşın.",
    badge3Title: "Veriye Dayalı",
    badge3Desc: "Hissiyata değil, içgörü ve kriterlere güvenin.",
    step1Title: "Size Uygun Paketi Seçin",
    step1Desc: "",
    step2Title: "İlanınızı Oluşturun",
    step2Desc: "",
    step3Title: "Skorlanmış CV’ler ve tamamlanmış mülakatlarla en uygun adaylar karşınızda!",
    step3Desc: "",
    talentOffer1Title: "CV Analizi",
    talentOffer1Desc: "CV’nizi yüklediğinizde sistemimiz, özgeçmişinizi analiz eder; eksik bilgilerden zayıf anlatımlara, gereksiz detaylardan format tutarsızlıklarına geliştirilmesi gereken noktaları belirler. Ardından CV’nizi daha profesyonel ve etkili hale getirecek net, kişiye özel öneriler sunar.",
    talentOffer2Title: "İşe Hazırlık Mülakatı",
    talentOffer2Desc: "Rolünüze ve şirkete göre gerçekçi AI mülakat provası yapın; video, ses veya yazılı modda ilerleyin. Anlık geri bildirim alın, zayıf cevaplar için örnek iyileştirmeler görün, ortalama skorlarla benchmark yapın ve görüşmeye özgüvenle girin.",
    talentOffer3Title: "Pozisyon Bazlı Gelişim",
    talentOffer3Desc: "Hedeflediğiniz role göre yetkinlik boşluklarınızı skor bazlı görün; teknik ve davranışsal alanlarda kişiselleştirilmiş mikro görevler, okunacak kaynaklar ve pratik setleriyle haftalık gelişim rotası oluşturun.",
    dashboardPreview: "Dashboard Önizleme",
    totalEvaluations: "Toplam Başvuru",
    thisMonth: "bu ay",
    interviewCompleted: "Mülakat Tamamlandı",
    minutesAgo: "5 dakika önce"
  },
  stats: {
    stat1Value: "7/24",
    stat1Label: "Mülakat Deneyimi",
    stat2Value: "3 Kat",
    stat2Label: "Zaman Tasarrufu",
    stat3Value: "%97",
    stat3Label: "Tutarlılık Oranı"
  },
  why: {
    title: "Neden HireThink?",
    reason1Title: "Maliyetleri Düşürün",
    reason1Desc: "Geleneksel mülakat süreçlerinin toplam maliyetini 4 kat'a kadar azaltın.",
    reason2Title: "Verimliliği Artırın",
    reason2Desc: "AI tabanlı ön eleme ile doğru adaylara daha hızlı ulaşın. Nitelikli aday bulma süresini kısaltın.",
    reason3Title: "Objektif Değerlendirme",
    reason3Desc: "Önyargısız, standartlaştırılmış değerlendirmeler ile en iyi kararları verin."
  },
  features: {
    title: "İşe Alım AI Çözümleri",
    subtitle: "İnsan kaynakları süreçlerinize yapay zeka optimizasyonunu HireThink ile başlatın.",
    feature1Title: "Yapay Zeka ile CV Skorlama",
    feature1Desc: "Tüm başvurularınızı tek sayfada toplayın, farklı formatlarda ki CV'leri isterseniz başvuru yönlendirerek isterseniz toplu bir şekilde yükleyerek yapay zeka ile değerlendirin ve kriterlerinize göre puanlayın.",
    feature2Title: "AI İşe Alım Mülakatı",
    feature2Desc: "Bir günde yüzlerce aday, yapay zeka destekli sanal asistan ile mülakat gerçekleştirebilir. Mülakat sonuçlarını dakikalar içinde görebilir, gelişmiş anomali kontrolü sayesinde sıradışı durumları kolayca tespit ederek kayıtları inceleyip detaylı kontrol sağlayabilirsiniz.",
    feature3Title: "Engelsiz Mülakat",
    feature3Desc: "Konuşma veya işitme engeli bulunan adaylar için, işaret dilini anlayan ve yazılı iletişimi destekleyen yapay zeka ile tam erişilebilir, engelsiz mülakat deneyimi sunun.",
    feature4Title: "Yabancı Dil Yeterlilik Görüşmesi",
    feature4Desc: "Türkçe, İngilizce, Almanca, İspanyolca, Fransızca, İtalyanca ve birçok dilde mülakat desteği ile global yetenek havuzuna erişin; adayların yabancı dil yeterliliğini standart ve objektif kriterlerle değerlendirin.",
    feature5Title: "Yetkinlik Analizi",
    feature5Desc: "İletişim, liderlik, problem çözme gibi 14+ yetkinlik setinde detaylı ve objektif aday değerlendirmesi.",
    feature6Title: "Psikometrik Değerlendirmeler",
    feature6Desc: "Adayların kişilik analizlerini ve bilişsel ve davranışsal eğilimlerini psikometrik testlerle ölçerek daha isabetli ve objektif işe alım kararları verin.",
    feature7Title: "Eğitim Modülleri",
    feature7Desc: "Adayların eksik yönlerini ve gelişim alanlarını AI tabanlı modüller ile belirleyin ve eğitim planlarınızı oluşturun.",
    feature8Title: "Aday Takip Sistemi (ATS)",
    feature8Desc: "Tüm adaylarınızı tek platformda takip edin, CV skorlamadan işe alıma kadar tüm süreçleri kolayca yönetin.",
    feature9Title: "Terfi Görüşmeleri & Vaka Çalışmaları",
    feature9Desc: "AI tabanlı terfi değerlendirmeleri ve vaka çalışmaları ile iç yetenekleri keşfedin.",
    feature10Title: "AI ile Aday Önerme Sistemi",
    feature10Desc: "Yapay zeka ile işe alımda, ilanınıza başvuran adaylar ile sınırlı kalmayın. İlanınız için en uygun adayları keşfedin ve teklif gönderin.",
    feature11Title: "Şikayet ve Öneri Modülü",
    feature11Desc: "Çalışanlarınızdan ve müşterilerinizden yapılandırılmış geri bildirim toplayarak İK süreçlerinizi sürekli iyileştirin.",
    feature12Title: "AI İşten Çıkış Mülakatları",
    feature12Desc: "Çalışan deneyimini anlayın, değerli geri bildirimler toplayın ve kurumsal gelişimi destekleyin."
  },
  howItWorks: {
    title: "Nasıl Çalışır?",
    subtitle: "Dakikalar içinde işe alım sürecinizi optimize edin",
    cvScoringTitle: "CV Skorlama Modülü",
    cvStep1Title: "İlanınızı Yayınlayın",
    cvStep1Desc: "Mevcut ilanınızı HireThink başvuru sayfasına yönlendirin ya da toplu CV yüklemesi yaparak yapay zeka ile değerlendirin.",
    cvStep2Title: "CV Değerlendirmelerini Görün",
    cvStep2Desc: "Gelen başvuruların CV skorlarını saniyeler içerisinde görün.",
    cvStep3Title: "Mülakat Daveti Gönderin",
    cvStep3Desc: "Belirlediğiniz adaylara toplu mülakat daveti gönderin.",
    interviewTitle: "Yapay Zeka Mülakat",
    intStep1Title: "Mülakatınızı Oluşturun",
    intStep1Desc: "Yapay zeka ile soru setinizi, yetkinliklerinizi, sorularınızı, başlangıç - bitiş tarihleri gibi ayarlarınızı belirleyin ve mülakat akışınızı yapılandırın.",
    intStep2Title: "Toplu Davet Gönderin",
    intStep2Desc: "CV skorlamadan veya diğer sistemlerden gelen adaylara tek tıkla davet gönderin veya excel ile adayları içe aktarıp davet gönderin.",
    intStep3Title: "Analizleri Görüntüleyin",
    intStep3Desc: "Tamamlanan mülakatların skor ve analizlerini panel üzerinden inceleyin, diğer adaylar ile kıyaslamalarına bakın ve sonuçları dışa aktarın."
  },
  competencies: {
    title: "Yetkinlik Setleri",
    subtitle: "Pozisyonunuza uygun yetkinlikleri seçin ve yetkinlik analizi ile doğru adaylara ulaşın.",
    communication: "İletişim Becerileri",
    teamwork: "Takım Çalışması",
    problemSolving: "Problem Çözme",
    decisionMaking: "Karar Verme",
    leadership: "Liderlik",
    adaptability: "Uyum Sağlama / Esneklik",
    responsibility: "Sorumluluk Alma",
    planning: "Planlama ve Organizasyon",
    goalOrientation: "Hedef Odaklılık",
    personalDevelopment: "Kişisel Gelişim",
    customerFocus: "Müşteri Odaklılık",
    analyticalThinking: "Analitik Düşünme",
    innovation: "Yenilikçilik",
    ethics: "Etik ve Değer Odaklılık",
    languagesTitle: "Çoklu Dil Desteği",
    languagesSubtitle: "Farklı dil seçenekleri ile mülakat oluşturabilir, global yetenek havuzuna erişebilirsiniz.",
    turkish: "Türkçe",
    english: "İngilizce",
    german: "Almanca",
    french: "Fransızca",
    spanish: "İspanyolca",
    italian: "İtalyanca",
    portuguese: "Portekizce",
    dutch: "Hollandaca",
    polish: "Lehçe",
    czech: "Çekçe",
    swedish: "İsveççe",
    norwegian: "Norveççe",
    danish: "Danca",
    romanian: "Romence",
    hungarian: "Macarca",
    finnish: "Fince",
    croatian: "Hırvatça",
    slovenian: "Slovence",
    slovak: "Slovakça",
    catalan: "Katalanca",
    estonian: "Estonca",
    latvian: "Letonca",
    lithuanian: "Litvanca",
    albanian: "Arnavutça",
    bosnian: "Boşnakça",
    macedonian: "Makedonca",
    maltese: "Malta Dili",
    luxembourgish: "Lüksemburgca",
    afrikaans: "Afrikanca",
    azerbaijani: "Azerbaycanca",
    indonesian: "Endonezce",
    malay: "Malayca",
    maori: "Maorice",
    tagalog: "Tagalog",
    vietnamese: "Vietnamca",
    languagesNote: "Yapay zeka tabanlı altyapımız ile 30+ dili destekliyoruz. Okunuşunu beğenmediğiniz kelimeler için yapay zekamızı admin paneli üzerinden anında eğitebiliyorsunuz.",
    moreLanguagesChip: "+ Daha fazla dil",
    imageAlt: "Yetkinlik setleri görseli",
    analysisTitle: "Esnek Analiz Konfigürasyonu",
    qaAnalysis: "Soru-Cevap Analizi",
    talentAnalysis: "Yetkinlik Analizi",
    analysisNote: "Esnek analiz konfigürasyonu ile öğrenci programları ve yüksek seviye işe alımlarınız için farklı yetkinlik ağırlıkları belirleyebilirsiniz."
  },
  integrations: {
    title: "Favori Araçlarınızla Entegre",
    subtitle: "Mevcut iş akışlarınıza kolayca entegre edin, verimliliğinizi artırın.",
    seeAll: "Tüm Entegrasyonlar"
  },
  testimonials: {
    title: "Hızlı. Güvenilir. Uygun Fiyatlı.",
    subtitle: "Müşterilerimiz ne diyor?",
    quote1: "HireThink sayesinde mülakat süreçlerimizi %60 hızlandırdık. Artık doğru adaylara çok daha kısa sürede ulaşabiliyoruz.",
    author1: "Ayşe Yılmaz",
    role1: "İK Direktörü",
    company1: "TechCorp",
    quote2: "AI tabanlı değerlendirmeler önyargısız ve tutarlı sonuçlar sunuyor. En iyi kararları vermemize yardımcı oluyor.",
    author2: "Mehmet Kaya",
    role2: "İşe Alım Müdürü",
    company2: "FinanceHub",
    quote3: "Kullanımı inanılmaz kolay ve raporlar çok detaylı. Tüm ekibimiz çok memnun.",
    author3: "Zeynep Demir",
    role3: "HR Manager",
    company3: "StartupX",
    trustedBy: "Güvenilen Şirketler"
  },
  cta: {
    headline1: "İşe Alım Sürecinizi",
    headline2: "Dönüştürmeye",
    headline3: "Hazır mısınız?",
    subtitle: "Hemen HireThink'i kullanmaya başlayın ve işe alım süreçlerinin geleceğini keşfedin.",
    button: "Hemen Başlayın",
    orContact: "veya iletişime geçin →"
  },
  footer: {
    email: "info@hirethink.ai",
    description: "",
    kvkkCompliant: "KVKK Uyumlu",
    iso27001: "ISO 27001",
    about: "Hakkımızda",
    pricing: "Fiyatlandırma",
    blog: "Blog",
    careers: "Kariyer",
    contact: "İletişim",
    faq: "SSS",
    newsletter: "Bülten",
    solutions: "Çözümler",
    premiumInterview: "Premium Canlı AI Mülakat",
    standardInterview: "Standart Videolu AI Mülakat",
    voiceInterview: "Sesli AI Mülakat",
    textInterview: "Yazılı AI Mülakat",
    peerInterview: "Ekip Bazlı Seçim",
    whatsappInterview: "WhatsApp AI Mülakat",
    phoneInterview: "Telefon AI Mülakat",
    interviewObserver: "AI Mülakat Gözlemcisi",
    cvScoring: "CV Skorlama",
    videoInterview: "Video Mülakat",
    avatarInterview: "AI Avatar Mülakat",
    cvAnalysis: "CV Analizi",
    interviewPrep: "İşe Hazırlık Mülakatı",
    roleGrowth: "Pozisyon Bazlı Gelişim",
    legal: "Yasal",
    terms: "Kullanım Şartları",
    privacy: "Gizlilik Politikası",
    kvkk: "KVKK",
    cookies: "Çerez Politikası",
    distanceSales: "Mesafeli Satış Sözleşmesi",
    deliveryReturn: "Teslimat ve İade Şartları",
    copyright: "© 2025 HireThink Yapay Zeka Teknolojileri A.Ş. Tüm hakları saklıdır.",
    address: "Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer / İstanbul",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    emailLabel: "E-posta"
  },
  contact: {
    title: "Bize Ulaşın",
    subtitle: "Size en kısa sürede dönüş yapalım",
    pageTitle: "İletişim",
    pageSubtitle: "Sorularınız, önerileriniz veya iş birliği teklifleriniz için bizimle iletişime geçin.",
    infoTitle: "İletişim Bilgileri",
    formTitle: "İletişim Formu",
    formDescription: "Aşağıdaki butona tıklayarak iletişim formunu açabilir ve mesajınızı gönderebilirsiniz.",
    openForm: "İletişim Formunu Aç",
    email: "E-posta",
    phone: "Telefon",
    address: "Adres",
    fullAddress: "Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer / İstanbul",
    vkn: "Vergi Kimlik No",
    companyName: "Şirket",
    fullName: "Ad Soyad",
    fullNamePlaceholder: "Adınız Soyadınız",
    emailPlaceholder: "ornek@email.com",
    phonePlaceholder: "0555 123 45 67",
    employeeCount: "Çalışan Sayısı",
    employeeCountPlaceholder: "Çalışan sayısını seçin",
    submit: "Gönder",
    submitting: "Gönderiliyor...",
    successTitle: "Başarılı!",
    successMessage: "Mesajınız alınmıştır. Kısa sürede size ulaşacağız.",
    appointmentDescription: "Randevu oluşturmak veya toplantı planlamak için takvim sayfamızı kullanabilirsiniz.",
    appointmentCta: "Randevu Oluştur"
  },
  calendar: {
    pageTitle: "Takvim",
    pageSubtitle: "Uygun zaman aralığı seçip randevu oluşturun.",
    prev: "Önceki",
    next: "Sonraki",
    today: "Bugün",
    day: "Gün",
    week: "Hafta",
    month: "Ay",
    refresh: "Yenile",
    loading: "Takvim yükleniyor...",
    loadError: "Takvim verisi yüklenemedi.",
    createTitle: "Randevu Oluştur",
    createSubtitle: "Takvimde bir zaman aralığı seçerek formu açabilirsiniz.",
    openCreate: "Yeni Randevu Aç",
    formTitle: "Yeni Randevu",
    formSubtitle: "Seçtiğiniz zaman aralığı için bilgileri girin.",
    customerName: "Ad Soyad",
    customerEmail: "E-posta",
    customerPhone: "Telefon",
    startTime: "Başlangıç",
    endTime: "Bitiş",
    duration: "Süre (dk)",
    notes: "Notlar",
    cancel: "Vazgeç",
    submit: "Kaydet",
    submitting: "Kaydediliyor...",
    createError: "Randevu oluşturulamadı.",
    emptySelection: "Geçerli bir zaman aralığı seçin.",
    halfHourError: "Saatler 30 dakikalık aralıklarla olmalı.",
    durationFixedError: "Tüm randevular 30 dakikadır.",
    durationFixedValue: "30 dk",
    emailError: "Geçerli bir e-posta adresi girin.",
    phoneError: "Geçerli bir telefon numarası girin.",
    phoneCountry: "Ülke Kodu",
    phoneCountryTR: "Türkiye (+90)",
    phoneCountryUS: "ABD (+1)",
    phoneCountryGB: "Birleşik Krallık (+44)",
    phoneCountryDE: "Almanya (+49)",
    detailsTitle: "Randevu Detayı",
    noSelection: "Detay görmek için bir randevu seçin.",
    status: "Durum",
    statusUnknown: "Bilinmiyor",
    unknownCustomer: "Aday",
    instructionsTitle: "Nasıl Kullanılır",
    instructionsText: "Randevu almak istediğiniz tarih ve saatin üstüne tıklayın veya saat aralığını sürükleyerek seçin. Form otomatik açılır.",
    instructionsNote: "Süre seçenekleri yalnızca 30 ve 60 dakikadır.",
    apiAlertTitle: "Uyarı",
    close: "Kapat"
  },
  pricing: {
    title: "Fiyatlandırma",
    subtitle: "İşletmenizin büyüklüğüne uygun paketi seçin, işe alım süreçlerinizi optimize edin.",
    monthlyPayment: "Aylık Ödeme",
    yearlyPayment: "Yıllık Ödeme",
    savePercent: "(25% İndirimli)",
    yearlyTotal: "Yıllık ödeme",
    starterName: "Başlangıç",
    starterDesc: "Küçük işletmeler ve başlangıç seviyesi işe alım süreçleri için ideal paket.",
    starterCta: "Başlayın",
    professionalName: "Profesyonel",
    professionalDesc: "Büyüyen şirketler ve yoğun işe alım süreçleri için kapsamlı çözüm.",
    professionalCta: "Başlayın",
    professionalPopular: "En Popüler",
    enterpriseName: "Ultimate",
    enterpriseDesc: "Şirket ihtiyaçlarınıza özel çözümler veya sınırsız kullanım.",
    enterpriseCta: "İletişime Geçin",
    custom: "Özel",
    starterFeature1: "15 Avatarlı AI Mülakatı veya 50 AI Mülakatı",
    starterFeature2: "500 CV Skorlama",
    starterFeature3: "2 Kullanıcı Hesabı",
    starterFeature4: "Sınırsız İlan Oluşturma",
    starterFeature5: "Sınırsız Soru Oluşturma",
    starterFeature6: "Yetkinlik Raporlama",
    starterFeature7: "Anomali Raporları",
    starterFeature8: "Gelişmiş Analitik",
    starterFeature9: "Ortalama Aday Sonuçları",
    starterFeature10: "Yetkinlik Setleri",
    starterFeature11: "Ekip Arkadaşı Görüşmesi (Peer Interview)",
    starterFeature12: "ATS",
    starterFeature13: "Psikometrik Değerlendirme",
    starterFeature14: "Standart Destek",
    starterFeature15: "Oryantasyon & Kurum İçi Eğitim Modülü",
    starterFeature16: "Şikayet & Memnuniyet Yönetimi",
    starterFeature17: "Telefon Mülakatı",
    starterFeature18: "AI Referans Kontrolü",
    textInterview300: "300 Yazılı (Text) Mülakat",
    whatsappInterview: "WhatsApp Mülakatı",
    aiCandidateSearch: "Yapay Zeka ile Aday Arama",
    aiOfferSuggestion: "AI ile Maaş Teklifi Önerisi",
    professionalFeature1: "300 Avatarlı AI Mülakatı veya 600 AI Mülakatı",
    professionalFeature2: "8,000 CV Skorlama",
    professionalFeature3: "8 Kullanıcı Hesabı",
    professionalFeature4: "Sınırsız İlan Oluşturma",
    professionalFeature5: "Sınırsız Soru Oluşturma",
    professionalFeature6: "Yetkinlik Raporlama",
    professionalFeature7: "Anomali Raporları",
    professionalFeature8: "Gelişmiş Analitik",
    professionalFeature9: "Ortalama Aday Sonuçları",
    professionalFeature10: "Yetkinlik Setleri",
    professionalFeature11: "Ekip Arkadaşı Görüşmesi (Peer Interview)",
    professionalFeature12: "ATS",
    professionalFeature13: "İlan kapatma raporları",
    professionalFeature14: "Psikometrik Değerlendirme",
    professionalFeature15: "Öncelikli Destek",
    professionalFeature16: "Oryantasyon & Kurum İçi Eğitim Modülü",
    professionalFeature17: "Şikayet & Memnuniyet Yönetimi",
    professionalFeature18: "Telefon Mülakatı",
    professionalFeature19: "AI Referans Kontrolü",
    enterpriseFeature1: "İhtiyaca göre çözümler",
    enterpriseFeature2: "Dedike hesap yöneticisi",
    enterpriseFeature3: "Özel Raporlamalar",
    enterpriseFeature4: "Psikometrik Değerlendirme",
    enterpriseFeature5: "7/24 öncelikli destek",
    enterpriseFeature6: "Özel eğitim ve onboarding",
    enterpriseFeature7: "Özel entegrasyonlar",
    enterpriseFeature8: "Firmaya Özel LLM Çözümleri",
    enterpriseFeature9: "AI Tabanlı Şikayet & Memnuniyet Yönetimi",
    enterpriseFeature10: "Oryantasyon & Kurum İçi Eğitim Modülü",
    enterpriseFeature11: "Telefon Mülakatı",
    enterpriseFeature12: "AI Referans Kontrolü",
    perMonth: "/ ay"
  },
  talentProducts: {
    title: "Aday Ürünleri",
    subtitle: "İş arama süreciniz için üç temel AI tabanlı adım: analiz, prova, gelişim. Her biri rolünüze göre kişiselleşir ve ölçülebilir geri bildirim üretir.",

    // Free AI CV Builder Section
    freeCvBadge: "%100 Ücretsiz",
    freeCvTitle: "Yapay Zeka ile Profesyonel CV'nizi Ücretsiz Hazırlayın",
    freeCvDesc: "Sıfırdan CV yazmakla uğraşmayın. Bilgilerinizi girin, yapay zeka sizin için ATS uyumlu, işe alım uzmanlarının aradığı formatta profesyonel bir CV oluştursun. Kredi kartı gerekmez, dakikalar içinde indirin.",
    freeCvPoint1: "Dakikalar içinde hazır CV",
    freeCvPoint2: "ATS uyumlu profesyonel şablonlar",
    freeCvPoint3: "AI destekli metin önerileri",
    freeCvCta: "Ücretsiz CV Oluştur",
    freeCvHint: "isbulsun.com üzerinde ücretsiz oluşturun",

    // CV Analysis Section
    cvAnalysisBadge: "Yapay Zeka CV Analizi",
    cvAnalysisTitle: "CV Analizi",
    cvAnalysisDesc: "CV'nizi yapay zeka ile tarayın; ATS uyumluluğu, okunabilirlik, etki gücü ve rol uyumu için ayrı ayrı puan alın.",
    cvAnalysisDescLong: "CV'nizi yapay zeka destekli analiz motorumuza yükleyin ve saniyeler içinde kapsamlı bir değerlendirme raporu alın. ATS sistemleri tarafından okunabilirliğinizi, sektör standartlarına uyumunuzu, etki yaratan ifadelerinizi ve hedef pozisyonla örtüşme oranınızı detaylı olarak görün. Rakip adayların öne çıktığı alanları keşfedin, eksik kalan bölümler için AI tabanlı öneri cümleleri alın ve CV'nizi işe alım uzmanlarının görmek istediği formata dönüştürün.",
    cvFeature1Title: "ATS Uyumluluk Skoru",
    cvFeature1Desc: "Otomatik tarama sistemlerinin CV'nizi nasıl gördüğünü öğrenin.",
    cvFeature2Title: "Sektör Karşılaştırması",
    cvFeature2Desc: "Benzer pozisyonlardaki adaylarla CV'nizi kıyaslayın.",
    cvFeature3Title: "Akıllı Öneriler",
    cvFeature3Desc: "Her bölüm için somut iyileştirme önerileri alın.",
    cvFeature4Title: "Başarı Metrikleri",
    cvFeature4Desc: "Etki yaratan ifadelerle başarılarınızı ölçülebilir hale getirin.",
    cvCheck1: "Satır satır geliştirme önerileri",
    cvCheck2: "Okunabilirlik ve format analizi",
    cvCheck3: "Anahtar kelime optimizasyonu",
    cvMockTitle: "CV Analiz Raporu",
    cvMockSubtitle: "Yazılım Mühendisi Pozisyonu",
    cvMockScore: "Genel Skor",
    cvScoreATS: "ATS Uyumluluğu",
    cvScoreImpact: "Etki Gücü",
    cvScoreReadability: "Okunabilirlik",
    cvScoreRole: "Pozisyon Uyumu",
    cvSuggestionTitle: "AI Önerisi",
    cvSuggestionText: "\"Proje yönettim\" yerine \"5 kişilik ekiple 3 ayda %40 verimlilik artışı sağlayan projeyi yönettim\" gibi somut metrikler ekleyin.",
    cvFloatLabel: "Dönüş Oranı Artışı",
    cvFloatAI: "AI Tabanlı Analiz",
    
    // Interview Prep Section
    interviewPrepBadge: "AI Mülakat Provası",
    interviewPrepTitle: "İşe Hazırlık Mülakatı",
    interviewPrepDesc: "Gerçek iş senaryolarına göre dinamik soru setleriyle pratik yapın.",
    interviewPrepDescLong: "Hedeflediğiniz pozisyon ve şirket profiline göre özelleştirilmiş mülakat simülasyonları ile kendinizi hazırlayın. Video, ses veya yazılı modda gerçek mülakat deneyimi yaşayın. Yapay zeka anında geri bildirim sağlar: cevap yapınızı ve içerik kalitesini değerlendirir. Diğer adayların ortalama puanlarıyla performansınızı kıyaslayın, teknik doğruluk ve iletişim netliği üzerinden detaylı puanlama alın. Her zayıf yanıt için alternatif örnek cevaplar ve geliştirme önerileri ile özgüveninizi artırın.",
    interviewFeature1Title: "Çoklu Mülakat Modu",
    interviewFeature1Desc: "Video, ses veya yazılı formatta pratik yapın.",
    interviewFeature2Title: "Anlık AI Analizi",
    interviewFeature2Desc: "Cevaplarınız gerçek zamanlı değerlendirilir.",
    interviewFeature3Title: "Örnek Cevaplar",
    interviewFeature3Desc: "Her soru için alternatif ideal cevaplar görün.",
    interviewFeature4Title: "Aday Karşılaştırması",
    interviewFeature4Desc: "Diğer adaylarla performansınızı kıyaslayın.",
    interviewCheck1: "150+ pozisyona özel soru seti",
    interviewCheck2: "Ortalama puanlarla performans kıyası",
    interviewCheck3: "Sektörel mülakat senaryoları",
    interviewRecording: "Kayıt Yapılıyor",
    interviewQuestion: "Bize kendinizden ve kariyer hedeflerinizden bahseder misiniz?",
    interviewModeVideo: "Video",
    interviewModeVoice: "Ses",
    interviewModeText: "Yazılı",
    interviewFeedbackTitle: "Anlık Değerlendirme",
    interviewScoreClarity: "Netlik",
    interviewScoreStructure: "Yapı",
    interviewScoreConfidence: "Güven",
    interviewFloatInstant: "Anlık Geri Bildirim",
    interviewFloatQuestions: "Soru Bankası",
    
    // Role Growth Section
    roleGrowthBadge: "Kariyer Gelişimi",
    roleGrowthTitle: "Pozisyon Bazlı Gelişim",
    roleGrowthDesc: "Hedeflediğiniz pozisyona göre yetkinlik boşluklarınızı görün.",
    roleGrowthDescLong: "Kariyer hedefinize ulaşmak için gereken yetkinlikleri net bir şekilde görün. Yapay zeka, mevcut becerilerinizi hedef pozisyonun gereksinimleriyle karşılaştırır ve kişiselleştirilmiş bir gelişim rotası oluşturur. Haftalık mikro görevler, seçilmiş kaynaklar, pratik setleri ve mini değerlendirmelerle sistematik olarak ilerleyin. Teknik ve davranışsal yetkinliklerdeki boşluklarınızı kapatırken güçlü yönlerinizi de geliştirin.",
    growthFeature1Title: "Yetkinlik Haritası",
    growthFeature1Desc: "Güçlü ve gelişime açık alanlarınızı görselleştirin.",
    growthFeature2Title: "Küratörlü Kaynaklar",
    growthFeature2Desc: "Hedefinize uygun eğitim içerikleri ve makaleler.",
    growthFeature3Title: "Mikro Görevler",
    growthFeature3Desc: "Günlük pratiklerle sürekli gelişim sağlayın.",
    growthFeature4Title: "İlerleme Takibi",
    growthFeature4Desc: "Gelişiminizi ölçülebilir metriklerle takip edin.",
    growthCheck1: "Kişiselleştirilmiş öğrenme yolu",
    growthCheck2: "Haftalık ilerleme raporları",
    growthCheck3: "Sektörel benchmark karşılaştırması",
    growthMockTitle: "Gelişim Panosu",
    growthMockSubtitle: "Product Manager Hedefi",
    skillTechnical: "Teknik Bilgi",
    skillCommunication: "İletişim",
    skillLeadership: "Liderlik",
    skillProblem: "Problem Çözme",
    skillAdaptability: "Uyum Sağlama",
    skillTeamwork: "Takım Çalışması",
    weeklyTasksTitle: "Bu Haftanın Görevleri",
    task1: "Etkili mülakat cevapları makalesini oku",
    task2: "2 adet davranışsal soru provası yap",
    task3: "Liderlik vaka çalışmasını tamamla",
    growthFloatProgress: "Haftalık İlerleme",
    growthFloatResources: "50+ Kaynak"
  },
  blog: {
    title: "Blog",
    subtitle: "Yapay zeka, işe alım ve insan kaynakları hakkında güncel içerikler",
    post1Title: "Yapay Zeka ile İşe Alım Süreçlerini Dönüştürmek",
    post1Excerpt: "Modern işe alım süreçlerinde yapay zeka teknolojilerinin nasıl devrim yarattığını keşfedin.",
    post2Title: "CV Skorlama: Doğru Adayı Bulmanın Yeni Yolu",
    post2Excerpt: "AI destekli CV skorlama sistemleri ile binlerce başvuruyu dakikalar içinde değerlendirin.",
    post3Title: "Geleceğin Mülakat Teknolojileri",
    post3Excerpt: "Video, ses ve yazılı AI mülakatlarının işe alım süreçlerine katkılarını inceleyin.",
    categoryAI: "Yapay Zeka",
    categoryHR: "İnsan Kaynakları",
    categoryTechnology: "Teknoloji",
    readMore: "Devamını Oku",
    comingSoon: "Daha fazla içerik yakında eklenecek. Bizi takip etmeye devam edin!"
  },
  career: {
    title: "Kariyer",
    subtitle: "HireThink ailesine katılın ve yapay zeka teknolojilerinin geleceğini birlikte şekillendirelim",
    noOpeningsTitle: "Şu anda açık pozisyon bulunmamaktadır",
    noOpeningsDesc: "Şu anda aktif iş ilanımız bulunmamaktadır. Ancak gelecekte açılacak pozisyonlar için bizi takip edebilir veya özgeçmişinizi gönderebilirsiniz.",
    stayTuned: "Bizi takip etmeye devam edin",
    valuesTitle: "Değerlerimiz",
    value1Title: "Takım Çalışması",
    value1Desc: "Birlikte çalışarak daha güçlü çözümler üretiyoruz.",
    value2Title: "İnovasyon",
    value2Desc: "Sürekli öğrenme ve gelişim kültürü ile yenilikçi çözümler sunuyoruz.",
    value3Title: "Mükemmellik",
    value3Desc: "Her projede en yüksek kalite standartlarını hedefliyoruz.",
    linkedinText: "Açık pozisyonlarımızdan haberdar olmak için LinkedIn sayfamızı takip edin",
    followLinkedIn: "LinkedIn'de Takip Et",
    aiBadge: "YENİ • AI Destekli İş Arama",
    aiTitle1: "Hayalindeki İşi",
    aiTitle2: "Yapay Zeka ile Bul",
    aiSubtitle: "Ne tür bir iş aradığını doğal dille anlat. AI, sana uygun pozisyonları anında sıralar.",
    aiPlaceholder: "Örn: İstanbul'da hibrit çalışabileceğim, 3+ yıl deneyim gerektiren React geliştirici pozisyonu arıyorum...",
    aiButton: "AI ile Ara",
    aiSearching: "Yapay zeka ilanları analiz ediyor...",
    aiResultsCount: "pozisyon bulundu",
    aiNoResults: "Aramanla eşleşen ilan bulunamadı. Farklı anahtar kelimeler deneyin.",
    aiClear: "Temizle",
    aiExampleLabel: "Örnek:",
    aiExample1: "Remote React Geliştirici",
    aiExample2: "Hibrit AI/ML Mühendisi",
    aiExample3: "İstanbul Ürün Yöneticisi",
    aiExample4: "Uzaktan UI/UX Tasarımcı",
    aiInputLabel: "İş araması",
    openingsTitle: "Açık Pozisyonlar",
    openingsCount: "açık ilan",
    jobViewDetail: "Detayları Gör",
    jobNotFound: "İlan Bulunamadı",
    jobNotFoundDesc: "Aradığınız iş ilanı mevcut değil veya kaldırılmış olabilir.",
    detailBack: "İş İlanlarına Dön",
    detailShare: "Paylaş",
    detailApply: "Hemen Başvur",
    detailAbout: "Pozisyon Hakkında",
    detailResponsibilities: "Görev ve Sorumluluklar",
    detailRequirements: "Aranan Nitelikler",
    detailBenefits: "Yan Haklar",
    detailInfo: "Pozisyon Bilgileri",
    detailLocation: "Konum",
    detailWorkType: "Çalışma Modeli",
    detailDepartment: "Departman",
    detailExperience: "Deneyim",
    detailSalary: "Maaş Aralığı",
    detailPosted: "İlan tarihi:",
    detailDeadline: "Son başvuru:",
    detailApplyTitle: "Bu pozisyon için başvurmaya hazır mısın?",
    detailApplySubtitle: "HireThink AI destekli mülakat süreci ile kısa sürede geri dönüş alacaksın. Başvurunu iletişim sayfamızdan yapabilirsin.",
    simTitle: "Bu Pozisyon İçin Uygunluğunu Ölç",
    simSubtitle: "HireThink Yapay Zeka İK Asistanı ile bu pozisyona özel bir mülakat simülasyonu gerçekleştir. Güçlü yönlerini ve gelişim alanlarını hemen keşfet.",
    simButton: "AI Simülasyonunu Başlat",
    simNote: "Simülasyon sonuçları sana özeldir. Hiçbir verin işe alım uzmanıyla paylaşılmaz."
  },
  faq: {
    title: "Sık Sorulan Sorular",
    subtitle: "HireThink Sık Sorulan Sorular",
    items: [
      {
        question: "HireThink nedir?",
        answer:
          "HireThink, yapay zeka destekli işe alım ve mülakat platformudur. CV skorlama, canlı AI avatar mülakat, asenkron video mülakat, sesli AI mülakat, yazılı AI mülakat, yetkinlik ve kişilik değerlendirmeleri, ekip bazlı mülakat (peer interview), aday takip sistemi (ATS) ve eğitim modüllerini tek çatı altında sunar. İşe alım sürecini ortalama %70 hızlandırır, CV eleme süresini %80 azaltır."
      },
      {
        question: "AI mülakat nasıl çalışır?",
        answer:
          "İş ilanı oluşturulduktan sonra adaylara otomatik mülakat bağlantısı e-posta ile gönderilir. Aday herhangi bir uygulama indirmeden tarayıcı veya telefondan mülakata katılır. Yapay zeka; içerik, ton, akıcılık ve yetkinlik göstergelerini gerçek zamanlı ya da mülakat tamamlandıktan sonra dakikalar içinde analiz ederek yapılandırılmış rapor üretir."
      },
      {
        question: "HireThink KVKK ve GDPR uyumlu mu?",
        answer:
          "Evet. HireThink hem Kişisel Verilerin Korunması Kanunu (KVKK) hem de AB Genel Veri Koruma Yönetmeliği (GDPR) standartlarına tam uyumludur. KVKK uyumu platformun temel tasarım ilkelerinden biridir; sonradan eklenmemiştir. Tüm mülakat kayıtları şifreli güvenli sunucularda saklanır. Veri işleme ve saklama politikası şeffaf biçimde yayımlanmıştır."
      },
      {
        question: "HireThink hangi sektörler için uygundur?",
        answer:
          "Teknoloji, finans, perakende, lojistik, sağlık, çağrı merkezi, üretim ve yoğun işe alım yapan tüm sektörler için uygundur. Özellikle toplu işe alım, uzaktan çalışma ve hızlı büyüme dönemlerinde etkindir. Türk iş piyasasına özgü gereksinimleri (KVKK, İş Kanunu uyumu, Türkçe destek) karşılayan yerli bir platform olmasıyla küresel rakiplerden ayrışır."
      },
      {
        question: "HireThink mevcut İK yazılımımla entegre olur mu?",
        answer:
          "Evet. HireThink, API entegrasyonu aracılığıyla Kolay İK, Logo İK Bulut, SAP SuccessFactors gibi mevcut İK ve ERP sistemleriyle bağlantı kurabilir. Kariyer.net, LinkedIn ve Indeed üzerinden gelen başvurular ATS'e aktarılabilir. Google Calendar ve Outlook Calendar entegrasyonu da desteklenmektedir. Detaylı entegrasyon bilgisi için info@hirethink.ai ile iletişime geçin."
      },
      {
        question: "Premium canlı AI mülakat ile standart video mülakat arasındaki fark nedir?",
        answer:
          "Premium Canlı AI Avatar Mülakat gerçek zamanlı, interaktif bir mülakat deneyimidir: AI avatar aday ile canlı konuşur, anlık yetkinlik analizi yapar. Standart Video AI Mülakat ise asenkrondur: aday soruları kendi zamanında video olarak kaydeder, AI sonra değerlendirir. Canlı mülakat daha derin yetkinlik ölçümü sağlarken standart mülakat takvim koordinasyonu gerektirmeden ölçeklenebilir."
      },
      {
        question: "HireThink ile toplu işe alım yapılabilir mi?",
        answer:
          "Evet. Excel ile toplu aday yükleme, otomatik davet gönderimi ve eş zamanlı birden fazla mülakat oturumu desteğiyle HireThink toplu işe alıma özellikle uygundur. CV skorlama modülü yüzlerce başvuruyu saniyeler içinde puanlayarak shortlist oluşturur."
      },
      {
        question: "Hangi AI modelleri kullanılıyor?",
        answer:
          "HireThink; Anthropic Claude, OpenAI GPT, Google Gemini, AWS Bedrock, Azure OpenAI, Meta Llama, Mistral, DeepSeek ve Hugging Face modellerini entegre eden çok modelli bir altyapı üzerinde çalışır. Avatar sesi ElevenLabs ses sentezi teknolojisiyle 30'dan fazla dilde doğal konuşma kalitesinde sunulur."
      },
      {
        question: "HireThink'in fiyatlandırması nasıl?",
        answer:
          "Fiyatlandırma şirket büyüklüğüne, kullanım ihtiyacına ve seçilen modüllere göre değişmektedir. Aylık ve yıllık ödeme seçenekleri mevcuttur. Detaylı fiyat bilgisi için demo talep edebilirsiniz: info@hirethink.ai veya 0850 307 80 61."
      },
      {
        question: "Demo alabilir miyim?",
        answer:
          "Evet. info@hirethink.ai adresinden veya sitemizdeki iletişim formu üzerinden demo talep edebilirsiniz. Ekibimiz en kısa sürede sizinle iletişime geçer."
      },
      {
        question: "Cevaplama süresi ne kadar?",
        answer:
          "Cevap verme süresi, mülakatı oluştururken seçtiğiniz süreye bağlıdır. Süre dolmadan birkaç saniye önce adaya görsel bir uyarı gösterilir ve bu süre içinde yanıtını tamamlaması beklenir. Süre dolduktan sonra verilen yanıtlar geçerli sayılmaz."
      },
      {
        question: "Aday mülakata ne zaman katılabilir?",
        answer:
          "Mülakat davetini gönderdiğiniz anda adaya e-posta ile bir bağlantı iletilir. Aday, davetin geçerlilik süresi boyunca dilediği zaman mülakata katılabilir."
      },
      {
        question: "Gönderdiğim video mülakatı adayın tamamlaması ne kadar sürer?",
        answer:
          "Bu süre tamamen sizin mülakat ayarlarınıza bağlıdır. Mülakat için bir başlangıç ve bitiş zamanı belirleyebilirsiniz. Belirlediğiniz zaman aralığı sona erdiğinde davet geçersiz hale gelir."
      },
      {
        question: "Aday, belirlenen süre içinde video mülakatı tamamlamazsa ne olur?",
        answer:
          "Aday mülakatı yarıda bıraktıysa ve mülakat hâlâ geçerlilik süresi içindeyse, aynı bağlantı üzerinden tekrar girip kaldığı yerden devam edebilir. Bu durum Anomali Raporlarında size bildirilir. Ancak belirlediğiniz zaman aralığı bittiyse davet geçersiz sayılır."
      },
      {
        question: "Aday mülakatı tamamlamadan kapatırsa kaldığı yerden devam edebilir mi?",
        answer:
          "Evet. Mülakat hâlâ geçerliyse aynı link üzerinden tekrar girerek kaldığı yerden devam edebilir. Bu durum Anomali Tespiti / Anomali Raporlarında size bildirilir."
      },
      {
        question: "Adaya sorabileceğim örnek sorular var mı?",
        answer:
          "Evet. Soru bankamızdan soru seçebilirsiniz. Soru bankasında hem genel hem de profesyonel sorular bulunur. Daha iyi ve role özel sorular için mülakatınızı oluşturduğunuzda AI ile soru üretebilirsiniz."
      },
      {
        question: "Adayları mülakata nasıl davet edebilirim?",
        answer:
          "3 farklı yöntemle davet gönderebilirsiniz: (1) “Adayları Mülakata Davet Et” butonundan tek tek ekleyerek, (2) Excel ile toplu yükleme yaparak, (3) İlan yönlendirmesi (başvuru yönlendirme) ile."
      },
      {
        question: "Neden mülakat davetleri sadece bazı adaylara gitti?",
        answer:
          "Eksik veya geçersiz bilgileri (ör. e-posta) olan adaylara davet gönderilemez. Bu durum sistem tarafından size bildirilir."
      },
      {
        question: "Gönderdiğim mülakatların tamamlanma durumunu nasıl kontrol edebilirim?",
        answer:
          "Birden fazla yol var: Dashboard’da son aday işlemlerini görebilir veya ilan detay sayfasına giderek tüm adayların durumlarını görüntüleyip duruma göre filtreleyebilirsiniz."
      },
      {
        question: "HireThink’te aday değerlendirme sürecimi nasıl yönetebilirim?",
        answer:
          "Mülakatı tamamlayan adayların videolarını izlerken HR Notes alanına notlar ekleyebilirsiniz. Ayrıca ATS sistemimiz üzerinden şirketinizdeki diğer İK kullanıcılarının notlarını da görüntüleyerek adayları karşılaştırabilirsiniz."
      },
      {
        question: "Mülakat sonuçlarını Excel olarak alabilir miyim?",
        answer:
          "Evet. “Export Excel” (Excel’e aktar) butonuna tıklayarak sonuçları kolayca Excel dosyası olarak indirebilirsiniz."
      },
      {
        question: "Adayları ad/soyad ve e-posta ile filtreleyerek arayabilir miyim?",
        answer:
          "Evet. Adaylar; ad, soyad, e-posta ve diğer birçok metrik ile gönderilmiş mülakatlar arasında aranabilir."
      },
      {
        question: "Pasif bir mülakatı nasıl aktif edebilirim?",
        answer:
          "Pasif bir mülakatı aktif etmek için “Edit Interview” (Mülakatı Düzenle) bölümüne girip durumunu “Active” (Aktif) olarak değiştirmeniz yeterlidir."
      },
      {
        question: "Daha önce oluşturduğum video mülakatı nasıl düzenleyebilirim?",
        answer:
          "Düzenlemek istediğiniz mülakatı seçip “Edit” / “Edit Interview” seçeneği ile gerekli değişiklikleri yapabilirsiniz."
      },
      {
        question: "Daha önce oluşturduğum mülakatların sorularını değiştirebilir miyim?",
        answer:
          "Henüz adaylara gönderilmemişse soruları ekleyip çıkarabilirsiniz. Ancak mülakat zaten adaylara gönderildiyse, yalnızca mülakat başlığını (title) güncelleyebilirsiniz."
      },
      {
        question: "Adaylara daha önce gönderdiğim bir mülakatın başlığını değiştirdim. Adaylara giden e-postalarda güncelleme olur mu?",
        answer:
          "Hayır. Başlık, sizin mülakatlarınızı takip etmeniz için kullanılan bir referans alanıdır; adaylara giden e-postaları etkilemez."
      },
      {
        question: "7 gün içinde aynı adaya farklı bir mülakat gönderebilir miyim?",
        answer:
          "Evet. Aynı adaya sınırsız sayıda mülakat gönderebilirsiniz."
      },
      {
        question: "Aday sonuçlarını ekip arkadaşlarımla nasıl paylaşabilirim?",
        answer:
          "Birden fazla yöntem var. En kolay yol paylaşılabilir linki iletmektir (alıcıların HireThink hesabı olmasa da görüntüleyebilirler). Ayrıca sonuçları PDF olarak dışa aktarıp ekibinizle paylaşabilirsiniz."
      },
      {
        question: "Mülakat davetleri adaylara nasıl iletiliyor?",
        answer:
          "Video mülakat davetleri adaylara e-posta ile gönderilir. Aday mülakata katılmazsa, son gün bir hatırlatma e-postası da gönderilir."
      },
      {
        question: "Bir ekip üyesi kullanıcıyı nasıl silebilirim?",
        answer:
          "Hesabınızdaki “Manage Members” (Üyeleri Yönet) bölümünden ilgili kullanıcıyı seçip “Delete” (Sil) ile kaldırabilirsiniz."
      },
      {
        question: "Kullanıcı bilgilerimi nasıl düzenleyebilirim?",
        answer:
          "Kullanıcı adınıza tıklayıp “Edit Profile” (Profili Düzenle) bölümünden ad, soyad ve şifre bilgilerinizi güncelleyebilirsiniz."
      },
      {
        question: "HireThink ne kadar ücretli?",
        answer:
          "Seçtiğiniz pakete göre değişir. Paket fiyatları aylık veya yıllık olarak farklılaşır."
      },
      {
        question: "Aboneliğimi iptal edebilir miyim?",
        answer:
          "Evet. Abonelik bilgileri (subscription information) bölümünden aboneliğinizi iptal edebilirsiniz."
      }
    ]
  },
  ats: {
    heroTitle1: "ATS",
    heroTitle2: "Aday Takip Sistemi",
    windowTitle: "HireThink ATS",
    heroSubtitle: "Tüm başvuruları tek platformda toplayın, aday havuzunuzdan maksimum verim alın ve kabul sonrası süreçleri otomatikleştirin. İşe alım sürecinizin her aşamasını merkezi bir sistemden yönetin.",
    imageAlt: "ATS Dashboard",
    floatBadge1Title: "Aday Havuzu",
    floatBadge1Desc: "Akıllı eşleştirme",
    floatBadge2Title: "Süreç Takibi",
    floatBadge2Desc: "Otomatik yönetim",
    floatBadge3Title: "Merkezi Platform",
    floatBadge3Desc: "Tek yerden yönetim",
    featuresTitle: "ATS Özellikleri",
    featuresSubtitle: "İşe alım sürecinizi optimize eden güçlü ATS sistemi",
    feature1Title: "Merkezi Başvuru Yönetimi",
    feature1Desc: "Tüm iş ilanlarınızı ve başvurularını tek bir platformda toplayın. Farklı kaynaklardan gelen başvuruları kolayca yönetin.",
    feature2Title: "Aday Havuzu",
    feature2Desc: "Başka pozisyonlara başvuran adaylarınızın mevcut yeteneklerini ve deneyimlerini görüntüleyin. Diğer ilanlarınız için uygun olup olmadıklarını anında kontrol edin ve AI destekli analiz ile en uygun eşleşmeleri keşfedin. Mevcut aday havuzunuzdan maksimum verim alın.",
    feature3Title: "Süreç Takibi",
    feature3Desc: "Adayınızın kabul sonrası tüm süreçlerini tek platformdan yönetin. Online işe giriş evraklarının yüklenmesi, sözleşme gönderimi, onboarding hazırlıkları ve diğer idari işlemleri merkezi bir sistem üzerinden takip edin. Süreçlerin hiçbir aşamasını kaçırmayın.",
    feature4Title: "Aday Takip",
    feature4Desc: "Adayların başvuru durumlarını, mülakat sonuçlarını ve değerlendirme notlarını tek yerden takip edin.",
    feature5Title: "Ekip İşbirliği",
    feature5Desc: "Ekip üyelerinizle notlar paylaşın, adayları karşılaştırın ve ortak kararlar alın.",
    feature6Title: "Entegrasyonlar",
    feature6Desc: "Mevcut HR sistemlerinizle entegre olun ve iş akışınızı optimize edin."
  },
  assessments: {
    badgeLabel: "Psikometrik Değerlendirmeler",
    heroTitle1: "Psikometrik",
    heroTitle2: "Değerlendirme Merkezi",
    heroSubtitle: "Kişilik ve iş stili, bilişsel kapasite ve durumsal yargı testleriyle adaylarınızın potansiyelini, dünyada yaygın kabul gören değerlendirme prensiplerini temel alan yapay zeka algoritmalarıyla dakikalar içinde, objektif ve tutarlı biçimde ölçün.",
    windowTitle: "HireThink Psikometrik Değerlendirme",
    heroImageAlt: "Psikometrik değerlendirme ekranı",
    badge1Title: "Kabul Görmüş Yöntemler",
    badge1Desc: "Dünyada yaygın kullanılan test prensipleri",
    badge2Title: "Çok Boyutlu Ölçüm",
    badge2Desc: "Kişilik, bilişsel, SJT",
    badge3Title: "Standart Akış",
    badge3Desc: "Davet, test, rapor, paylaşım",
    sectionLabel: "Akıllı Modüller",
    sectionTitle: "Psikometri + yetkinlik tek panelde",
    sectionSubtitle: "Kişilik & iş stili, bilişsel ve durumsal yargı testlerini yetkinlik ve vaka akışlarıyla birleştirip karar hızınızı artırın.",
    module1Title: "Psikometrik Paket",
    module1Desc: "Kişilik, değerler ve iş stili profillerini modern envanterlerle çıkarın; bilişsel hız ve dikkat ölçümleriyle tamamlayın.",
    module1Bullets: [
      "Kişilik & iş stili haritası",
      "Bilişsel hız, dikkat, çalışma belleği",
      "Norm ve rol eşiklerine göre skor"
    ],
    module2Title: "Süreç Akışı",
    module2Desc: "AI, rol ve seviye seçimine göre uygun test paketini ve soru setini önerir; siz onaylayıp tek tıkla davet gönderirsiniz.",
    module2Bullets: [
      "Rol/seviye bazlı hazır şablonlar",
      "Toplu davet & güvenli oturum",
      "Anlık tamamlama takibi"
    ],
    module3Title: "Raporlama & Güvenlik",
    module3Desc: "Psikometrik ve yetkinlik skorlarını tek raporda; yapay zeka tarafından üretilen detaylı analiz ve içgörülerle, KVKK uyumlu saklama, paylaşılabilir linkler ve kapsamlı özetler.",
    module3Bullets: [
      "Rol uyumu ve risk uyarıları",
      "Psikometrik özet & içgörü kartları",
      "KVKK/GDPR uyumlu erişim"
    ],
    pillarsLabel: "Psikometrik Boyutlar",
    pillarsTitle: "Üç temel eksende kapsamlı ölçüm",
    pillarsSubtitle: "Her test paketi Kişilik & İş Stili, Bilişsel kapasite ve Durumsal Yargı (SJT) skorlarını tek ekranda birleştirir.",
    pillar1Title: "Kişilik & İş Stili",
    pillar1Desc: "İş değerleri, motivasyon, ekip içi çalışma stili ve stresle başa çıkma profillerini ölçün.",
    pillar1Bullets: [
      "Beş faktör tabanlı kişilik ölçekleri",
      "Liderlik, müşteri odaklılık, işbirliği profilleri",
      "Rol bazlı güçlü yön & risk uyarıları"
    ],
    pillar2Title: "Bilişsel",
    pillar2Desc: "Çalışma belleği, dikkat, sayısal ve sözel akıl yürütme hızını kısa, adaptif testlerle puanlayın.",
    pillar2Bullets: [
      "Zaman bazlı skorlar ve hız/doğruluk dengesi",
      "Gürültüye dayanıklılık ve odak ölçümleri",
      "Norm grubu ve eşik kıyasları"
    ],
    pillar3Title: "Durumsal Yargı (SJT)",
    pillar3Desc: "Gerçek iş senaryolarında adayın karar verme biçimini, değer uyumunu ve önceliklendirmesini değerlendirin.",
    pillar3Bullets: [
      "Rolünüze göre lokalize senaryolar",
      "Seçilen aksiyonlara göre ağırlıklı skorlar",
      "Önyargı azaltıcı, standartlaştırılmış akış"
    ],
    flowLabel: "Akış",
    flowTitle: "Dakikalar içinde psikometrik akış kurun",
    flowSubtitle: "Rol seç, paket önerisini onayla, daveti gönder; rapor tek ekranda hazır.",
    flow1Title: "Rol & Seviye Seçimi",
    flow1Desc: "Hedef rolü, seniority’yi ve değerlendirmek istediğiniz yetkinlik/pisikometrik ağırlıkları belirleyin.",
    flow2Title: "Paket Seçimi",
    flow2Desc: "Kişilik & İş Stili + Bilişsel + SJT testlerini rol ve seviye için birlikte seçin; süre ve soru sayısını siz belirlersiniz.",
    flow3Title: "Güvenli Davet",
    flow3Desc: "Tek tıkla davet; kimlik doğrulama, gözetim ve anomali kontrolleriyle şeffaf oturumlar.",
    flow4Title: "Rapor & Paylaşım",
    flow4Desc: "Psikometrik özet kartları, kıyas tabloları ve gelişim önerileri tek raporda; PDF ve paylaşılabilir link.",
    aiAdvantageLabel: "Yapay Zeka Avantajı",
    aiAdvantageTitle: "Neden yapay zeka ile değerlendirme?",
    aiAdvantageSubtitle: "Dünyada yaygın kabul gören değerlendirme prensiplerini temel alan algoritmalarımız, testleri geleneksel yöntemlere kıyasla çok daha hızlı, ekonomik ve tutarlı şekilde puanlar.",
    highlight1Title: "Dakikalar İçinde Sonuç",
    highlight1Desc: "Testler tamamlanır tamamlanmaz yapay zeka puanlama ve detaylı analiz yapar; günler sürebilen manuel değerlendirme süreci dakikalara iner.",
    highlight2Title: "Daha Düşük Maliyet",
    highlight2Desc: "Dış danışmanlık ve uzman değerlendirici maliyetlerine kıyasla çok daha ekonomik; sınırsız sayıda adayı aynı standartla değerlendirin.",
    highlight3Title: "İnsan Hatası ve Önyargı Riski Ortadan Kalkar",
    highlight3Desc: "Standart algoritmik puanlama sayesinde değerlendirmeci yorgunluğu, dikkat dağınıklığı ve bilinçsiz önyargıdan kaynaklanan hatalar devre dışı kalır.",
    ctaLabel: "Demo Talep",
    ctaTitle: "Psikometrik değerlendirmeyi hemen başlatın",
    ctaSubtitle: "Tek panelde Kişilik & İş Stili, Bilişsel ve Durumsal Yargı testlerini yönetin, standart raporlar alın.",
    ctaPrimary: "Demo Talep Et",
    ctaSecondary: "Satışla Görüş"
  },
  training: {
    heroTitle1: "Personel",
    heroTitle2: "Eğitim & Oryantasyon",
    windowTitle: "HireThink Eğitim Modülleri",
    heroSubtitle: "Şirketinizde ki çalışanlar için zorunlu eğitimleri AI destekli modüller ile yönetin. İlerleme takibi, değerlendirme testleri ve detaylı raporlama ile eğitim süreçlerinizi optimize edin.",
    imageAlt: "Eğitim Modülleri Dashboard",
    floatBadge1Title: "Zorunlu Eğitimler",
    floatBadge1Desc: "Takım odaklı",
    floatBadge2Title: "Anlık Testler",
    floatBadge2Desc: "Eğitim içi değerlendirme",
    floatBadge3Title: "1000+ Avatar",
    floatBadge3Desc: "Çeşitli seçenekler",
    featuresTitle: "Eğitim Modülü Özellikleri",
    featuresSubtitle: "Çalışanlarınız için zorunlu eğitimleri yöneten AI tabanlı eğitim platformu",
    feature2Title: "Kişiselleştirilmiş Eğitim Planları",
    feature2Desc: "Şirket ihtiyaçlarınıza göre eğitim seçenekleri oluşturun.",
    feature1Title: "1000+ Avatar Seçeneği",
    feature1Desc: "Geniş avatar kütüphanesinden seçim yapın. Şirketinize ve konunuza en uygun avatarı seçin.",
    feature3Title: "Değerlendirme Testleri",
    feature3Desc: "Eğitim sırasında videonun ortasında çıkan testler ile çalışanların konuyu anlayıp anlamadığını anlık olarak değerlendirin. Eğitim sonrası konu hakimiyet testleri ile bilgi seviyesini ölçün.",
    feature4Title: "İlerleme Takibi",
    feature4Desc: "Çalışanlarınızın eğitim ilerlemelerini detaylı olarak takip edin. Tamamlanma durumlarını, test sonuçlarını ve katılım oranlarını görüntüleyin.",
    feature5Title: "Raporlama",
    feature5Desc: "Detaylı eğitim raporları ile çalışanların performansını analiz edin. Hangi eğitimlerin tamamlandığını, test başarı oranlarını ve gelişim alanlarını görüntüleyin.",
    feature6Title: "Odaklanmış Öğrenme",
    feature6Desc: "Eğitim videolarını geçilemez ve arka planda oynatılamaz hale getirin. Ekip arkadaşlarınızın tam odak konuları öğrendiğinden emin olun ve eğitim etkinliğini maksimize edin.",
    coursesBadge: "Canlı Eğitim Kataloğu",
    coursesTitle: "Sunduğumuz Eğitimler",
    coursesSubtitle: "Bunlar dijital modül değil; alanında uzman eğitmenlerimiz eşliğinde, online eğitim platformumuzda canlı olarak verdiğimiz gerçek kurumsal gelişim programlarıdır.",
    coursesCategory1: "İnsan Kaynakları & Analitik",
    coursesCategory1Item1: "İnsan Kaynakları Uzmanlık Eğitimi",
    coursesCategory1Item2: "İnsan Kaynakları Analitiği Eğitimi",
    coursesCategory1Item3: "Excel ve Yapay Zeka Eğitimi",
    coursesCategory1Item4: "İnsan Kaynaklarında Excel ve Yapay Zeka Eğitimi",
    coursesCategory2: "Liderlik & Yönetim Programları",
    coursesCategory2Item1: "Takım Lideri Yetiştirme Programı",
    coursesCategory2Item2: "Proje Lideri ve Yöneticisi Yetiştirme Programı",
    coursesCategory2Item3: "Öncelik Belirleme ve İş Planlaması",
    coursesCategory2Item4: "İş Süreçlerinde Sürdürülebilir Performans",
    coursesCategory2Item5: "Kriz Yönetimi",
    coursesCategory3: "Kişisel & Ekip Gelişimi",
    coursesCategory3Item1: "Takımda Farkındalık ve Birlikte Çalışma",
    coursesCategory3Item2: "Kalite Bilinci Oluşturma",
    coursesCategory3Item3: "Değişim ve Kişisel Gelişim",
    coursesCategory3Item4: "İletişim Yönetimi",
    coursesCategory3Item5: "Motivasyon ve İşe Bağlılık Geliştirme",
    coursesCategory3Item6: "Dokümantasyon ve Raporlama",
    coursesFootnote: "Listede aradığınız eğitimi bulamadınız mı? İhtiyacınıza özel içerik hazırlayalım.",
    coursesCta: "Eğitim Takvimini İnceleyin"
  },
  cookieConsent: {
    title: "Çerezler Hakkında",
    description: "Bu web sitesi, deneyiminizi iyileştirmek ve site performansını analiz etmek için çerezler kullanmaktadır. Çerez kullanımı hakkında daha fazla bilgi için",
    learnMore: "çerez politikamızı",
    acceptAll: "Tümünü Kabul Et",
    rejectAll: "Tümünü Reddet",
    settings: "Ayarlar",
    settingsTitle: "Çerez Tercihleri",
    settingsDescription: "Aşağıdaki çerez kategorilerinden istediğinizi seçebilirsiniz:",
    necessaryTitle: "Zorunlu Çerezler",
    necessaryDesc: "Web sitesinin çalışması için gerekli olan çerezler. Bu çerezler devre dışı bırakılamaz.",
    functionalTitle: "İşlevsel Çerezler",
    functionalDesc: "Dil tercihleri gibi kullanıcı ayarlarınızı hatırlamamıza yardımcı olan çerezler.",
    analyticsTitle: "Analitik Çerezler",
    analyticsDesc: "Web sitesinin nasıl kullanıldığını anlamamıza yardımcı olan çerezler (Google Analytics vb.).",
    marketingTitle: "Pazarlama Çerezleri",
    marketingDesc: "Size daha uygun içerik ve reklamlar göstermemize yardımcı olan çerezler.",
    cookiePolicy: "Çerez Politikası",
    cancel: "İptal",
    savePreferences: "Tercihleri Kaydet"
  },
  paymentModal: {
    invoiceInfo: "Fatura Bilgileri",
    payment: "Ödeme",
    yearly: "Yıllık",
    monthly: "Aylık",
    close: "Kapat",
    companyInfo: "Firma Bilgileri",
    companyName: "Firma Adı",
    companyNamePlaceholder: "Firma adınızı giriniz",
    taxNumber: "Vergi Numarası",
    taxNumberPlaceholder: "Vergi numaranızı giriniz",
    taxOffice: "Vergi Dairesi",
    taxOfficePlaceholder: "Vergi dairesi adınızı giriniz",
    address: "Adres",
    addressPlaceholder: "Firma adresinizi giriniz",
    authorizedPersonName: "Yetkili Kişi Adı",
    authorizedPersonNamePlaceholder: "Adınızı giriniz",
    authorizedPersonSurname: "Yetkili Kişi Soyadı",
    authorizedPersonSurnamePlaceholder: "Soyadınızı giriniz",
    email: "E-posta",
    emailPlaceholder: "ornek@firma.com",
    phone: "Telefon Numarası",
    phonePlaceholder: "+90 555 123 45 67",
    required: "gereklidir",
    invalidEmail: "Geçerli bir e-posta adresi giriniz",
    invalidPhone: "Geçerli bir telefon numarası giriniz",
    orderSummary: "Sipariş Özeti",
    plan: "Plan:",
    period: "Dönem:",
    unitPrice: "Birim Fiyat:",
    total12Months: "Toplam (12 Ay):",
    subtotal: "Ara Toplam:",
    vat: "KDV (%20):",
    total: "Toplam:",
    exchangeRateNote: "* Dolar kuru: 1 $ = {{rate}} ₺'den hesaplanmıştır.",
    proceedToPayment: "Ödemeye Git",
    cardInfo: "Kredi Kartı Bilgileri",
    cardNumber: "Kart Numarası",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    cardName: "Kart Sahibi Adı",
    cardNamePlaceholder: "AD SOYAD",
    expiryDate: "Son Kullanma",
    expiryDatePlaceholder: "MM/YY",
    cvv: "CVV",
    cvvPlaceholder: "123",
    paymentSummary: "Ödeme Özeti",
    back: "Geri",
    processing: "İşleniyor...",
    pay: "Öde",
    paymentFailed: "Ödeme Başarısız",
    paymentFailedMessage: "Bir hata oluştu hiçbir ücret çekilmedi",
    requiredField: "*",
    month: "Ay",
    months: "Ay"
  },
  interviewObserver: {
    badge: "AI Mülakat Gözlemcisi",
    heroTitle1: "Tarafsız AI Gözlemci",
    heroTitle2: "Canlı Mülakata Katılıyor",
    heroSubtitle: "Google Meet, Zoom veya Teams toplantınıza sessizce katılan HireThink Observer; hem adayı hem de mülakatı yapan İK uzmanını tarafsız ve objektif biçimde değerlendirir. Mülakat sürecinin kalitesini ve adaletini yapay zeka ile güvence altına alın.",
    floatBadge1Title: "Canlı İzleme",
    floatBadge1Desc: "Gerçek zamanlı analiz",
    floatBadge2Title: "Tarafsız Değerlendirme",
    floatBadge2Desc: "İki taraf için objektif",
    floatBadge3Title: "Detaylı Rapor",
    floatBadge3Desc: "Mülakat sonrası analiz",
    howTitle: "Nasıl Çalışır?",
    howSubtitle: "Toplantı botu gibi katılır, her şeyi izler ve kapsamlı rapor üretir",
    step1Title: "Botu Davet Edin",
    step1Desc: "Mülakat toplantısına HireThink Observer bot linkini paylaşın. Zoom, Google Meet veya Teams'e otomatik katılır.",
    step2Title: "Sessizce İzler",
    step2Desc: "Bot toplantıya gözlemci olarak katılır; ses ve video akışını gerçek zamanlı analiz eder, sürece müdahale etmez.",
    step3Title: "Canlı Uyarılar",
    step3Desc: "Yönlendirici sorular, ayrımcı ifadeler veya mülakat kalite sorunları tespit edildiğinde İK yöneticisine anlık bildirim gönderir.",
    step4Title: "Raporu İnceleyin",
    step4Desc: "Mülakat biter bitmez her iki taraf için ayrı, kapsamlı bir değerlendirme raporu sisteminize düşer.",
    featuresTitle: "Gözlemci Bot Özellikleri",
    featuresSubtitle: "Mülakat sürecini hem aday hem de İK tarafından bütünsel değerlendiren yapay zeka",
    feature1Title: "Gerçek Zamanlı Gözlem",
    feature1Desc: "Toplantıya sessiz bir gözlemci olarak katılan bot; konuşmaları, ses tonunu, soruları ve yanıtları milisaniyeler içinde işleyerek canlı metrikler üretir.",
    feature2Title: "İK Tarafsızlık Analizi",
    feature2Desc: "Mülakatı yürüten İK uzmanının sorularını hukuki uyumluluk, tarafsızlık ve profesyonellik açısından değerlendirir. Ayrımcı veya yönlendirici soru kalıplarını otomatik olarak işaretler.",
    feature3Title: "Hukuki Uyum Denetimi",
    feature3Desc: "Yaş, cinsiyet, medeni durum, din gibi ayrımcılık riski taşıyan konulara temas eden soruları tespit eder. Şirketinizi hukuki risklerden korur.",
    feature4Title: "Aday Yetkinlik Skoru",
    feature4Desc: "Adayın cevaplarını içerik, akıcılık, özgüven ve yetkinlik göstergelerine göre puanlar. Tüm mülakatlar için karşılaştırılabilir standart skorlar üretir.",
    feature5Title: "Kapsamlı Mülakat Raporu",
    feature5Desc: "Her mülakatın ardından İK performans raporu ve aday değerlendirme raporu ayrı ayrı oluşturulur. Paylaşılabilir, dışa aktarılabilir format.",
    feature6Title: "KVKK & GDPR Uyumlu",
    feature6Desc: "Tüm ses ve video analiz işlemleri şifreli altyapıda gerçekleşir. Katılımcılar bilgilendirilir, veriler yasal saklama sürelerine uygun yönetilir.",
    reportTitle: "İki Taraflı Değerlendirme Raporu",
    reportSubtitle: "Mülakat bittikten sonra hem aday hem de İK uzmanı için ayrı, kapsamlı raporlar otomatik oluşturulur",
    reportCandidateTitle: "Aday Raporu",
    reportCandidate1: "Yetkinlik bazlı skor ve detaylı analiz",
    reportCandidate2: "Sözel akıcılık ve özgüven değerlendirmesi",
    reportCandidate3: "Güçlü yönler ve gelişim alanları",
    reportCandidate4: "Diğer adaylarla karşılaştırmalı benchmark",
    reportHrTitle: "İK Performans Raporu",
    reportHr1: "Soru kalitesi ve tarafsızlık skoru",
    reportHr2: "Tespit edilen riskli soru kalıpları",
    reportHr3: "Mülakat süresi ve akış analizi",
    reportHr4: "Profesyonellik ve hukuki uyum değerlendirmesi",
    ctaTitle: "Mülakatlarınızı Güvence Altına Alın",
    ctaSubtitle: "HireThink Observer ile her mülakat tarafsız, standart ve hukuki açıdan güvenli olsun.",
    ctaButton: "Demo Talep Et"
  },
  newsletter: {
    badge: "Haftalık Bülten",
    heroTitle1: "Yapay Zeka ile İK",
    heroTitle2: "Nereye Gidiyor?",
    heroSubtitle: "İşe alımı, yetkinlik değerlendirmesini ve çalışan deneyimini kökten değiştiren yapay zeka dönüşümünü her hafta takip edin. Sektörün önüne geçin.",
    pill1: "Yapay Zeka Haberleri",
    pill2: "İK Trendleri",
    pill3: "Haftalık İçerik",
    formBadge: "Ücretsiz · Haftada Bir · İptal Edilebilir",
    formTitle: "İK ve Yapay Zekada Bir Adım Önde Olun",
    formSubtitle: "İşe alım süreçlerini dönüştüren yapay zeka gelişmelerini, öne çıkan İK stratejilerini ve sektör trendlerini her hafta doğrudan gelen kutunuza taşıyalım. Abone olmak ücretsizdir, istediğiniz zaman iptal edebilirsiniz.",
    firstName: "Ad",
    firstNamePlaceholder: "Adınız",
    lastName: "Soyad",
    lastNamePlaceholder: "Soyadınız",
    email: "E-posta",
    emailPlaceholder: "ornek@email.com",
    phone: "Telefon",
    phonePlaceholder: "0555 123 45 67",
    companyName: "Firma Adı",
    companyNamePlaceholder: "Şirketinizin adı",
    title: "Unvan",
    titlePlaceholder: "Örn: İK Müdürü",
    department: "Departman",
    departmentPlaceholder: "Örn: İnsan Kaynakları",
    birthDate: "Doğum Tarihi",
    consentText: "HireThink'ten haftalık bülten, ürün güncellemeleri ve sektör haberleri almayı kabul ediyorum. Aboneliğimi istediğim zaman iptal edebileceğimi biliyorum.",
    submit: "Abone Ol",
    submitting: "Kaydediliyor...",
    privacy: "Kişisel verileriniz KVKK kapsamında korunmaktadır. Bilgileriniz üçüncü taraflarla paylaşılmaz.",
    successTitle: "Bültene Üye Oldunuz!",
    successDesc: "Artık yapay zeka ile insan kaynakları alanında sizin bilginiz dışında bir gelişme olmayacak. İşe alımı, yetkinlik değerlendirmeyi ve çalışan deneyimini dönüştüren her gelişmeyi her hafta gelen kutunuza taşıyacağız.",
    successUnsubscribe: "İstediğiniz zaman gelen bülten e-postalarındaki \"Abonelikten Çık\" bağlantısından ayrılabilirsiniz.",
    counterLabel: "kişi zaten haberdar",
    counterSub: "Sen de onlarla birlikte bir adım önde ol.",
    errorRequired: "Bu alan zorunludur.",
    errorEmail: "Geçerli bir e-posta adresi giriniz.",
    errorConsent: "Devam etmek için bülteni onaylamanız gerekmektedir.",
    errorGeneric: "Bir hata oluştu. Lütfen tekrar deneyin."
  }
};

export default tr;
